import { useState, useMemo, useEffect } from 'react';

import { getAuctionInsightDataSource, clearCache } from '@bingads-webui-campaign-legacy/dashboard-cards/competition-card/data-fetch';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';

export function useAuctionInsightData({
  dateRange,
}) {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // Competition card is handling data internally
  // but we need to trigger a re-fetch when the date range changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataSource = useMemo(() => getAuctionInsightDataSource(), [dateRange]);

  useEffect(() => {
    setIsLoading(true);
    createAsyncToken(dataSource.query()).on({
      onSuccess: (chartData: any) => {
        setData(chartData);
        setIsLoading(false);
        clearCache();
      },
      onError: () => {
        setData(undefined);
        setIsLoading(false);
        clearCache();
      },
      onCancel: () => {
        setData(undefined);
        setIsLoading(false);
        clearCache();
      },
    });
  }, [dataSource]);

  return { data, isLoading };
}
